import ShieldFill from './ShieldFill';

export default ShieldFill;
